import { kaspreadsheetUrl } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=Artistic%20overhead%20flatlay%20composition%20of%20an%20assortment%20of%20contemporary%20fashion%20items%20including%20colorful%20sneakers%2C%20folded%20hoodies%2C%20baseball%20caps%2C%20and%20stylish%20accessories%20arranged%20organically%20on%20a%20warm%20cream%20linen%20surface%20with%20soft%20natural%20sunlight%20from%20a%20large%20window%2C%20editorial%20fashion%20photography%2C%20warm%20neutral%20beige%20and%20cream%20tones%2C%20Scandinavian%20minimalist%20aesthetic%2C%20clean%20composition%2C%20soft%20organic%20shadows&width=1800&height=1200&seq=hero-v2-main-n7a1&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/35"></div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-16 py-32 md:py-40">
        <div className="max-w-2xl">
          <span className="inline-block px-3 py-1.5 rounded-full bg-white/15 backdrop-blur-sm text-white/90 text-xs font-medium mb-6 tracking-wide uppercase animate-fade-in-up">
            Atualizado 2026
          </span>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-[1.08] mb-6 font-heading animate-fade-in-up-delay-1">
            Hoobuy Spreadsheet
            <br />
            <span className="text-white/85">Atualizado 2026</span>
            <br />
            <span className="text-white/70">Lista Completa</span>
          </h1>

          <p className="text-white/75 text-base md:text-lg max-w-lg mb-10 leading-relaxed animate-fade-in-up-delay-2">
            Descubra o <strong className="text-white/95">hoobuyspreadsheet</strong> mais
            completo da internet, com produtos testados, organizados e
            atualizados semanalmente pela comunidade.
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-3 animate-fade-in-up-delay-3">
            <a
              href={kaspreadsheetUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2.5 px-7 py-4 bg-primary-500 text-background-50 text-base font-semibold rounded-full hover:bg-primary-600 transition-all hover:scale-[1.02] whitespace-nowrap cursor-pointer"
            >
              hoobuy sheet
              <i className="ri-arrow-right-up-line text-lg"></i>
            </a>
            <a
              href={kaspreadsheetUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2.5 px-7 py-4 bg-white/15 backdrop-blur-sm text-white text-base font-semibold rounded-full border border-white/25 hover:bg-white/25 transition-all hover:scale-[1.02] whitespace-nowrap cursor-pointer"
            >
              buy it now
              <i className="ri-arrow-right-up-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a
          href="#categories"
          className="flex flex-col items-center gap-2 text-white/60 hover:text-white/90 transition-colors cursor-pointer"
        >
          <span className="text-xs font-medium tracking-wide uppercase">
            Explorar
          </span>
          <i className="ri-arrow-down-line text-lg animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}